import { createFileRoute } from '@tanstack/react-router';

import { RouterContext } from '~/types/router.type';

import { InvoiceV2Page } from '~/modules/invoice/v2';
import { LoadingPage } from '~/modules/router/components';

import { i18n } from '~/utils';
import { getRouteHead } from '~/utils/routeUtils';

import { getInvoiceDetail } from '../../../incoming/-routeParams';

import { invoiceDetailSearchSchema } from './-searchParams';

const title = i18n.t(($) => $.pageTitle.detail, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/v2/incoming/$invoiceId')(
  {
    beforeLoad: ({ context, params }) => getInvoiceDetail({ context, params }),
    component: InvoiceV2Page,
    head: ({ loaderData }: { loaderData?: RouterContext }) =>
      getRouteHead(`${title} ${loaderData?.pageData?.title ?? ''}`),
    loader: ({ context }) => context,
    remountDeps: ({ params }) => [params.invoiceId],
    pendingComponent: LoadingPage,
    staticData: {
      AppBar: {
        title,
      },
    },
    validateSearch: invoiceDetailSearchSchema,
    wrapInSuspense: true,
  },
);
